export default __webpack_public_path__ + "static/media/devices_wdc_suspended.91676781.svg";